const initState = {
  orderDetailData: {},
  returnRecords: [],
  isShowReturnRecordModal: false,
  returnProductID: [],
  refreshReturnFlag: true,
  isShowReturnBankModal: false,
  returnBankID: [],
  isShowReturnLogisticModal: false,
  returnLogisticModalData: [],
  returnB2BData: {},
  isShowReturnB2BModal: false,
};

export function orderDetailState(state = initState, action) {
  switch (action.type) {
    case 'GET_ORDER_DETAIL_DATA': {
      return {
        ...state,
        orderDetailData: action.payload,
      };
    }
    case 'SHOW_ORDER_DETAIL_RETURN_RECORDS_MODAL': {
      return {
        ...state,
        isShowReturnRecordModal: true,
      };
    }
    case 'CLOSE_ORDER_DETAIL_RETURN_RECORDS_MODAL': {
      return {
        ...state,
        isShowReturnRecordModal: false,
      };
    }
    case 'UPDATE_ORDER_DETAIL_RETURN_RECORDS': {
      return {
        ...state,
        returnRecords: action.payload,
      };
    }
    case 'POST_CHECK_RETURN_ENTRYNUMBERS': {
      return {
        ...state,
        returnProductID: [...action.payload],
      };
    }
    case 'UPDATE_REFRESH_RETURN_FLAG': {
      return {
        ...state,
        refreshReturnFlag: action.payload,
      };
    }
    case 'SHOW_ORDER_DETAIL_BANK_MODAL': {
      return {
        ...state,
        isShowReturnBankModal: action.payload,
      };
    }
    case 'UPDATE_RETURN_BANKID': {
      return {
        ...state,
        returnBankID: action.payload,
      };
    }
    case 'SHOW_RETURN_LOGISTIC_MODAL': {
      return {
        ...state,
        isShowReturnLogisticModal: action.payload,
      };
    }
    case 'UPDATE_RETURN_LOGISTIC_MODAL_DATA': {
      return {
        ...state,
        returnLogisticModalData: action.payload,
      };
    }
    case 'GET_RETURN_REQUESTB2B': {
      return {
        ...state,
        returnB2BData: action.payload,
      };
    }
    case 'SHOW_RETURN_REQUESTB2B_MODAL': {
      return {
        ...state,
        isShowReturnB2BModal: action.payload,
      };
    }
    default:
      return state;
  }
}

export default orderDetailState;